import React, { useEffect, useRef } from "react";
import { calendar } from "../../CustomControls/calendar"; // Import the calendar rendering logic
// import "../CustomControls/Calendar.css"; // Import your CSS for calendar styling
// import "../../assets/css/calendar.css";

const CalendarComponent = ({ config,Date }) => {
  const calendarRef = useRef(null); // Use ref to track the calendar DOM element
  const propDate=Date;
  useEffect(() => {
    // Initialize the calendar only after the component mounts and when config changes
    if (calendarRef.current) {
      calendar(calendarRef.current, config, propDate);
    }
  }, [config]); // Re-run when the config changes

  return <div ref={calendarRef} className="calendar-container"></div>;
};

export default CalendarComponent;
